export enum AddProgramFormFieldLabel {
  Medicine = "Odaberi lijek",
  ProgramTemplate = "Program",
  StartDate = "Datum početka programa",
}
